import {gsap} from 'gsap'
import {ScrollTrigger} from 'gsap/ScrollTrigger'
import {ScrollSmoother} from 'gsap/ScrollSmoother'
import 'is-in-viewport'
import {onScroll} from './transition'

gsap.registerPlugin(ScrollSmoother, ScrollTrigger)

const scrollSmoother = ScrollSmoother.create({
  smooth: 2, // how long (in seconds) it takes to "catch up" to the native scroll position
  speed: 1,
  // smoothTouch: 0.1, // much shorter smoothing time on touch devices (default is NO smoothing on touch devices)
  effects: true, // looks for data-speed and data-lag attributes on elements
  onUpdate: () => onScroll(),
  onStop: () => onScroll,
})

ScrollTrigger.config({ ignoreMobileResize: true })
ScrollTrigger.normalizeScroll(true)
